var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgScanQrMobileIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 56,
    viewBox: "0 0 80 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.6719 -11V-5.66797H85.668V10.3281H91V-11H69.6719Z",
    fill: "#49B3FF",
    fillOpacity: 0.35
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8418 -0.335938V26.3242H37.502V10.3281H42.834V4.99609H37.502V-0.335938H10.8418ZM32.1699 20.9922H16.1738V4.99609H32.1699V20.9922Z",
    fill: "#49B3FF",
    fillOpacity: 0.35
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1582 68.9805V42.3203H69.4941V36.9883H64.1621V42.3203H48.166V47.6523H53.498V52.9844H48.166V58.3164H53.498V68.9805H80.1582ZM58.8301 47.6523H74.8262V63.6484H58.8301V47.6523Z",
    fill: "#49B3FF",
    fillOpacity: 0.35
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8379 36.9883H37.502V31.6562H10.8418V36.9883H21.5059V42.3203H16.1738V47.6523H21.5059V58.3164H16.1738V63.6484H21.5059V68.9805H48.166V63.6484H42.834V58.3164H37.502V63.6484H26.8379V58.3164H32.1699V52.9844H26.8379V36.9883Z",
    fill: "#49B3FF",
    fillOpacity: 0.35
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5059 10.3281H26.8379V15.6602H21.5059V10.3281Z",
    fill: "#49B3FF",
    fillOpacity: 0.35
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1621 10.3281H69.4941V15.6602H64.1621V10.3281Z",
    fill: "#49B3FF",
    fillOpacity: 0.35
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4941 26.3242H80.1582V-0.335938H53.498V26.3242H64.1621V31.6562H69.4941V26.3242ZM58.8301 20.9922V4.99609H74.8262V20.9922H58.8301Z",
    fill: "#49B3FF",
    fillOpacity: 0.35
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1582 36.9883V31.6562C78.8682 31.6562 70.7931 31.6562 69.4941 31.6562V36.9883H80.1582Z",
    fill: "#49B3FF",
    fillOpacity: 0.35
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1621 52.9844H69.4941V58.3164H64.1621V52.9844Z",
    fill: "#49B3FF",
    fillOpacity: 0.35
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.834 47.6523H48.166V52.9844H42.834V47.6523Z",
    fill: "#49B3FF",
    fillOpacity: 0.35
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1699 52.9844H37.502C37.502 51.6944 37.502 43.6193 37.502 42.3203H32.1699V52.9844Z",
    fill: "#49B3FF",
    fillOpacity: 0.35
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M37.502 36.9883H42.834V42.3203H37.502V36.9883Z",
    fill: "#49B3FF",
    fillOpacity: 0.35
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1738 47.6523H10.8418V58.3164H16.1738C16.1738 57.0264 16.1738 48.9513 16.1738 47.6523Z",
    fill: "#49B3FF",
    fillOpacity: 0.35
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M42.834 -0.335938H48.166V4.99609H42.834V-0.335938Z",
    fill: "#49B3FF",
    fillOpacity: 0.35
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42.834 20.9922H48.166C48.166 19.7022 48.166 11.6271 48.166 10.3281H42.834V20.9922Z",
    fill: "#49B3FF",
    fillOpacity: 0.35
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M48.166 31.6562V26.3242H42.834V36.9883H64.1621V31.6562H48.166Z",
    fill: "#49B3FF",
    fillOpacity: 0.35
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScanQrMobileIcon);
export default __webpack_public_path__ + "static/media/ScanQRMobile_icon.89deb6f316830590617cf507b32709c6.svg";
export { ForwardRef as ReactComponent };